/* eslint-disable import/prefer-default-export */
import { useStore } from 'vuex';
import { computed } from 'vue';
import { useProduct } from '@modules/product';

function setToObj(store, { key, objKey, value }) {
  store.commit('extraStore/setToObj', {
    scope: 'protectionPlan', key, objKey, value,
  });
}

function deleteFromObj(store, { key, objKey }) {
  store.commit('extraStore/deleteFromObj', { scope: 'protectionPlan', key, objKey });
}

export function useSelectedProtectionPlan(initialValue) {
  const store = useStore();
  const { productId } = useProduct();

  const getSelectedProtectionPlan = () => store?.state?.extraStore?.protectionPlan?.selectedProtectionPlan?.[productId] || '';

  /**
   * @param {String} selectedPlanId
   * @returns {void}
   */
  const updateSelectedProtectionPlan = (selectedPlanId = '') => {
    if (selectedPlanId) {
      setToObj(store, { key: 'selectedProtectionPlan', objKey: productId, value: selectedPlanId });
    } else {
      deleteFromObj(store, { key: 'selectedProtectionPlan', objKey: productId });
    }
  };

  if (initialValue && !getSelectedProtectionPlan()) {
    updateSelectedProtectionPlan(initialValue);
  }

  const protectionPlan = computed({
    get: getSelectedProtectionPlan,
    set: updateSelectedProtectionPlan,
  });

  return { updateSelectedProtectionPlan, getSelectedProtectionPlan, protectionPlan };
}

export default useSelectedProtectionPlan;
